import React, { useRef, useEffect } from "react";
import Lottie from "lottie-react";

import trashicon from "../../Images/icons/trash.json"
import editicon from "../../Images/icons/edit.json"
import viewicon from "../../Images/icons/view.json"
import blindicon from "../../Images/icons/blind.json"
import educationicon from "../../Images/icons/education.json"
import bestEmploye from "../../Images/icons/best-employee.json"
import idea from "../../Images/icons/idea.json"
import file from "../../Images/icons/file.json"
import planning from "../../Images/icons/planning.json"
import novemeber from "../../Images/icons/november.json"
import bouncebackIcon from "../../Images/icons/bounce-back.json"
import threedots from "../../Images/icons/three-dots.json"
import downloadarrow from "../../Images/icons/download-arrow.json"
import searchicon from "../../Images/icons/Search01.json"
import menuicon from "../../Images/icons/Menu-White.json"

const icons = {
  trashIcon: trashicon,
  editIcon: editicon,
  viewIcon: viewicon,
  blindIcon: blindicon,
  educationIcon: educationicon,
  professionalExp: bestEmploye,
  idea: idea,
  personalInfo: file,
  professionalSummary: planning,
  novemeber: novemeber,

  bounceBackIcon :bouncebackIcon,
  threedotsIcon : threedots,
  downloadArrow :downloadarrow,
  searchIcon : searchicon,
  menuIcon :menuicon
};

const LottieIcon = ({ name, size = 24, isActive = false, shouldPlay = false }) => {
  const lottieRef = useRef();
  const animationData = icons[name];
  
    useEffect(() => {
    if (shouldPlay) {
      lottieRef.current?.play();
    } else {
      lottieRef.current?.stop();
    }
  }, [shouldPlay]);


  if (!animationData) return null;

  return (
    <div style={{ width: size, height: size }}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={false}
        autoplay={false}
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default LottieIcon;